import styled from 'styled-components'

export const Body = styled.div`
  display: flex;
  gap: 10rem;

  @media (max-width: 1279px) {
    flex-direction: column;
    gap: 8rem;
  }

  @media (max-width: 767px) {
    gap: 6rem;
  }
`

export const Column = styled.div``

export const Title = styled.h4`
  font-family: coolvetica, Arial, Helvetica, sans-serif;
  font-size: 2.4rem;
  line-height: 3rem;
  font-weight: 400;
  color: #292e3d;
  margin-bottom: 4rem;

  @media (max-width: 767px) {
    font-size: 2rem;
    line-height: 2.6rem;
  }
`

export const Grid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4rem;
`
